import { useQuery } from "@tanstack/react-query";
import { ShortActuality } from "../../models/shortActuality";
import { ActualitiesApi } from "../../services";
import { ActualityShort } from "../actualities/actualityShort";

export const NewActualities = () => {
    const { data: actualitiesData } = useQuery<ShortActuality[]>({
        queryKey: ["actualities"],
        queryFn: ActualitiesApi.getNewActualities,
    });
    const actualities = actualitiesData ?? [];

    return (
        <div className="flex flex-col mx-auto">
            <div className="text-4xl">
                Aktuality
            </div>
            <div className="mt-5 space-y-5">
                {
                    actualities?.map((actuality, key) => (
                        <ActualityShort key={key} name={actuality.name} createdAt={new Date(actuality.createdAt)} id={actuality.actualityId} />
                    ))
                }
            </div>
        </div>
    )
}